module.exports = __webpack_public_path__ + "static/media/sygnet.c8d5c2d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/sygnet.svg
// module id = 612
// module chunks = 0